import React from 'react';
import { Typography } from '@mui/material';

export const PayoutInfo = ({ payoutData }) => {
    if (!payoutData) return null;

    return (
        <div className="details-group">
            <Typography variant="h6" className="section-title">Payout Information</Typography>
            <div className="details-grid">
                <Typography variant="body1">
                    Math Model: {payoutData.mathModel?.payoutPercentage + '%' || 'N/A'}
                </Typography>
            </div>
        </div>
    );
};